module.exports = {
      id: "58ba5530556d70f7dc6abb469d35fff0construction-wood.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#58ba5530556d70f7dc6abb469d35fff0construction-wood.svg",
      toString: function () {
        return this.url;
      }
    }